import { Stack, Typography } from "@mui/material";
import { InnerBox } from "@/components/elements/InnerBox";
import { FCC } from "@/types/common";
import { TCaseMatches } from "@/api/services/main/case/dtos/get-case.dto";
import { text } from "@/theme/colors";
import { CaseEditMatchTable } from "@/features/case/components/CaseEdit/CaseEditMatchTable";

type TProps = {
  caseMatches: TCaseMatches[];
};

export const CaseEditMatches: FCC<TProps> = ({ caseMatches: _caseMatches = [] }) => {
  return (
    <InnerBox mt={3} showDivider={false} title={<Typography variant="head20Bold">マッチング一覧</Typography>}>
      <Stack direction="row" mt={2} mb={2}>
        <Typography variant="body14Semi" color={text.primary}>
          全 {1} 件中 {1} 件を表示
        </Typography>
      </Stack>
      <CaseEditMatchTable rows={[]} />
    </InnerBox>
  );
};
